/**
 * Create Project Handler
 * 
 * CQRS Command Handler that delegates to ProjectCommandService.
 * Thin adapter layer that transforms commands to application service calls.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { ICommandHandler } from '@swoft/core';
import { CreateProjectCommand } from '../commands/CreateProjectCommand';
import { ProjectCommandService } from '../services/ProjectCommandService';

@injectable()
export class CreateProjectHandler implements ICommandHandler<CreateProjectCommand, { projectId: string }> {
  constructor(
    @inject(DDD_SYMBOLS.ProjectCommandService) private projectCommandService: ProjectCommandService
  ) {}

  async handle(command: CreateProjectCommand): Promise<{ projectId: string }> {
    const result = await this.projectCommandService.createProject(command.payload);
    
    return { 
      projectId: result.projectId 
    };
  }
}